import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { BasicConfigurationModel } from '@/modules/settings/types/basic';
import { toast } from "@/lib/toasts/api";
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext';

const pickGusIdentifier = (payload: Partial<BasicConfigurationModel>) => {
  const nip = payload.nip?.replace(/\D/g, '')
  if (nip) {
    return { nip }
  }

  const regon = payload.regon?.replace(/\D/g, '')
  if (regon) {
    return { regon }
  }

  const krs = payload.krs?.trim()
  if (krs) {
    return { krs }
  }

  return {}
}

export function useMutateGusData(companyId: string) {
  const { t } = useLocalize();
  return useMutation({
    mutationFn: async (payload: Partial<BasicConfigurationModel>) => {
      const params = pickGusIdentifier(payload)
      const res = await axiosInstance.get('/config-api/company/importFromGus', {
        params,
      })
      const d = res.data
      return {
        name: d.name,
        legalStatus: d.legalStatus,
        nip: d.nip,
        regon: d.regon,
        krs: d.krs,
        email: d.email,
        street: d.street,
        buildingNumber: d.buildingNumber,
        flatNumber: d.flatNumber,
        postalCode: d.postalCode,
        post: d.post,
        city: d.city,
        officePhone: d.phone,
        fax: d.fax,
        www: d.website,
      } as Partial<BasicConfigurationModel>
    },

    onError: (error) => {
      console.error('Error fetching GUS data:', error);
      toast.error({
        text: t("configuration-basic.gus-fetch-error"),
      })
    },

    onSuccess: () => {
      toast.success({
        text: t("configuration-basic.gus-fetch-success"),
      })
    },
  });
}
